import { SIDEBAR_TRIGGER_ATTR } from "@core-ui/hooks/useSidebarFloating";
import { cn } from "@core-ui/utils/cn";
import { NAV_Z_INDEX } from "./leftNavigationLayoutConstants";

export const CollapsedNavigationHoverZone = () => (
	<div
		{...{ [SIDEBAR_TRIGGER_ATTR]: true }}
		className={cn(
			"fixed bottom-0 left-0 top-[var(--catalog-titlebar-offset,0rem)] w-[5px] cursor-ew-resize",
			NAV_Z_INDEX,
		)}
	/>
);
